import * as React from 'react';
import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[80px] w-full rounded-fd-sm bg-fd-surface-1 border border-fd-border',
        'px-3 py-2 font-geist text-[13.5px] text-fd-text placeholder:text-fd-text-subtle',
        'leading-relaxed resize-y',
        'transition-[border,box-shadow] duration-fd-fast ease-fd-out',
        'focus-visible:outline-none focus-visible:border-fd-accent-line',
        'focus-visible:shadow-[0_0_0_3px_var(--fd-accent-soft)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
